import React, { ReactElement } from 'react';
import {
  FieldPermissionFlagRenderPropsChildren,
  FieldPermissionFlagProps,
} from './FieldPermissionFlag.types';
import { useFieldPermissionFlag } from '../../hooks';

/**
 * This component checks whether the given 'field' or 'fields[]' should be visible.
 * If so then 'children' components are rendered, if not then nothing is rendered.
 * The visibility of fields is determined by fields in the 'registration' and 'brand'
 * contexts from the 'RegistrationStore' and 'BrandStore'.
 */
export function FieldPermissionFlag(
  props: FieldPermissionFlagProps & { log?: boolean },
): ReactElement | null {
  const { children } = props;

  let fields = props.field ? [props.field] : props.fields;
  fields = fields || [];

  const renderIf =
    typeof props.renderIf === 'string'
      ? [props.renderIf]
      : props.renderIf || ['read'];

  const fieldPermissions = useFieldPermissionFlag(...fields);

  if (typeof children === 'function') {
    return (children as FieldPermissionFlagRenderPropsChildren)(
      fieldPermissions,
    );
  } else {
    const shouldRender = renderIf.some(ri => fieldPermissions?.[ri]);
    return <>{shouldRender ? children : null}</>;
  }
}

export default FieldPermissionFlag;
